import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["slide", "nextButton", "previousButton"]

  static values = {
    index: Number,
    range: Number
  };

  next() {
    this.indexValue++
  }

  previous() {
    this.indexValue--
  }

  indexValueChanged() {
    this.showCurrentSlides()
    this.toggleSlideButtons()
  }

  showCurrentSlides() {
    this.slideTargets.forEach((element, index) => {
      element.hidden = index < this.indexValue || index > this.indexValue + this.rangeValue - 1
    })
  }

  toggleSlideButtons() {
    if (this.hasPreviousButtonTarget) {
      this.previousButtonTarget.style.visibility = this.indexValue === 0 ? "hidden" : "visible"
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.style.visibility = this.indexValue >= this.slideTargets.length - this.rangeValue ? "hidden" : "visible"
    }
  }
}
